export default __webpack_public_path__ + "static/media/icomoon.dbb1ad73.svg";